import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getPageMetadata, metadataElements } from "./metadata";

export default function PageMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    document.head.querySelectorAll("[data-echo-seo]").forEach(element => element.remove());
    for (const [tag, attributes, content] of metadataElements(getPageMetadata(pathname))) {
      const element = document.createElement(tag);
      element.setAttribute("data-echo-seo", "true");
      for (const [key, value] of Object.entries(attributes)) element.setAttribute(key, value);
      if (content) element.textContent = content;
      document.head.appendChild(element);
    }
  }, [pathname]);
  return null;
}
